import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { Grid } from 'gu-ui-kit'
import styles from 'modules/Finance/Wallets/subcomponents/Chart/subcomponents/BarChart/BarChart.module.scss'

export const BarChart = ({ colors, data }) => {
  const totalData = useMemo(() => data.reduce((acc, value) => acc + value, 0), [data])

  return (
    <Grid
      className={styles['bar-chart']}
      alignItems={'start'}
      justifyContent={'start'}
    >
      {colors.map((color, i) => (
        <div
          key={i}
          className={styles['bar-chart__item']}
          style={{
            backgroundColor: color,
            '--bar-width': Math.round((data[i] * 100) / totalData) + '%',
            zIndex: -i,
          }}
        />
      ))}
    </Grid>
  )
}

BarChart.propTypes = {
  labels: PropTypes.array,
  colors: PropTypes.array,
  data: PropTypes.array,
  currency: PropTypes.string,
}
